module.exports = __webpack_public_path__ + "img/139ne.4883e643.svg";